/**
 * Season display helpers.
 * "Сезон 2023-2024" / "2023-2024" → "23-24"
 */
export function formatSeasonShort(name) {
    const raw = String(name || '').trim();
    const match = raw.match(/(\d{2,4})\s*[-–]\s*(\d{2,4})/);
    if (!match) {
        return raw.replace(/^Сезон\s*/i, '').trim() || raw;
    }
    return `${match[1].slice(-2)}-${match[2].slice(-2)}`;
}

/**
 * Mobile team label: "Сезон 2023-2024" → "2023-24"
 */
export function formatSeasonYearShort(name) {
    const raw = String(name || '').trim();
    const full = raw.match(/(\d{4})\s*[-–]\s*(\d{2,4})/);
    if (full) {
        return `${full[1]}-${full[2].slice(-2)}`;
    }
    const short = raw.match(/(\d{2})\s*[-–]\s*(\d{2})/);
    if (short) {
        return `${short[1]}-${short[2]}`;
    }
    return raw.replace(/^Сезон\s*/i, '').trim() || raw;
}
